import React from "react";

import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import ReplyOutlinedIcon from "@material-ui/icons/ReplyOutlined";
import DoneOutlinedIcon from "@material-ui/icons/DoneOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import Grid from "@material-ui/core/Grid";

import "../styles.css";

const ButtonsCell = cellData => {
  return (
    <>
      {cellData.row.isEditing ? (
        <>
          <Tooltip title="Сохранить" placement="top-start">
            <IconButton
              onClick={() => cellData.component.saveEditData(cellData.rowIndex)}
            >
              <DoneOutlinedIcon fontSize="small" style={{ color: "#93A7BE" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Отмена" placement="top-start">
            <IconButton
              onClick={() =>
                cellData.component.cancelEditData(cellData.rowIndex)
              }
            >
              <ReplyOutlinedIcon
                fontSize="small"
                style={{ color: "#93A7BE" }}
              />
            </IconButton>
          </Tooltip>
        </>
      ) : (
        <Grid container>
          <Grid item>
            <Tooltip title="Редактировать" placement="top-start">
              <IconButton
                onClick={() => cellData.component.editRow(cellData.rowIndex)}
              >
                <EditOutlinedIcon
                  fontSize="small"
                  style={{ color: "#93A7BE" }}
                />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip title="Удалить" placement="top-start">
              <IconButton
                onClick={() => cellData.component.deleteRow(cellData.rowIndex)}
              >
                <DeleteForeverOutlinedIcon
                  fontSize="small"
                  style={{ color: "#93A7BE" }}
                />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ButtonsCell;
